import React from 'react';
import { Box, Text, Button, Modal } from '@mantine/core';

const PaymentOptionModal = (props) => {
    return <Modal
        opened={props?.opened}
        onClose={() => {
            props?.setOpened(false)
            props?.setSelectedPaymentOption("full")
        }}
        closeOnClickOutside={false}
        size="md"
        title="Select Payment Option"
        centered
        sx={() => ({
            '.mantine-Modal-title': {
                fontSize: 30,
                fontWeight: '600',
                color: "#1D2939"
            },
            '.mantine-oy9g3x': {
                backgroundColor: '#252a3d'
            },
            '@media (max-width: 480px)': {
                '.mantine-Modal-title': {
                    fontSize: "clamp(1rem, 6vw, 26px)"
                }
            }
        })}
    >
        {/* Modal content */}
        <Box style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start'
        }}>
            <Box
                role="button"
                style={{
                    display: 'inline-flex',
                    justifyContent: 'space-between',
                    alignItems: "center",
                    background: props?.selectedPaymentOption === "full" && "#FFE6DA",
                    width: "100%",
                    color: props?.selectedPaymentOption === "full" ? "#FA5000" : "#262626",
                    marginBottom: "1rem",
                    padding: "1rem",
                    border: "1px solid",
                    borderColor: props?.selectedPaymentOption === "full" ? "#FFE6DA" : "#1018281A",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 7px 0px #1018281A"
                }}
                onClick={() => {
                    props?.setSelectedPaymentOption("full")
                }}
            >
                <Box
                    role="button"
                    style={{
                        display: 'inline-flex',
                        alignItems: "center"
                    }}
                >
                    <svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.6666 17.0002L19.9999 19.3335L24.6666 14.6668M24.6666 7.66683H1.33325M24.6666 10.0002V5.56683C24.6666 4.26004 24.6666 3.60665 24.4123 3.10752C24.1886 2.66848 23.8316 2.31152 23.3926 2.08782C22.8934 1.8335 22.24 1.8335 20.9333 1.8335H5.06659C3.7598 1.8335 3.1064 1.8335 2.60727 2.08781C2.16823 2.31152 1.81127 2.66847 1.58757 3.10752C1.33325 3.60665 1.33325 4.26004 1.33325 5.56683V14.4335C1.33325 15.7403 1.33325 16.3937 1.58757 16.8928C1.81127 17.3318 2.16823 17.6888 2.60727 17.9125C3.1064 18.1668 3.7598 18.1668 5.06658 18.1668H12.9999" stroke="currentcolor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <Text
                        sx={() => ({
                            fontSize: 16,
                            fontWeight: 600,
                            marginLeft: "0.5rem"
                        })}
                    >
                        Full Payment
                    </Text>
                </Box>
                {props?.selectedPaymentOption === "full" ?
                    <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="14" fill="#FA5000" />
                        <path d="M20 9.5L11.75 17.75L8 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    :
                    <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#D0D0D0" />
                    </svg>
                }
            </Box>
            <Box
                role="button"
                style={{
                    display: 'inline-flex',
                    justifyContent: 'space-between',
                    alignItems: "center",
                    background: props?.selectedPaymentOption === "deposit" && "#FFE6DA",
                    width: "100%",
                    color: props?.selectedPaymentOption === "deposit" ? "#FA5000" : "#262626",
                    padding: "1rem",
                    border: "1px solid",
                    borderColor: props?.selectedPaymentOption === "deposit" ? "#FFE6DA" : "#1018281A",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 7px 0px #1018281A"
                }}
                onClick={() => {
                    props?.setSelectedPaymentOption("deposit")
                }}
            >
                <Box
                    role="button"
                    style={{
                        display: 'inline-flex',
                        alignItems: "center",
                    }}
                >
                    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.6666 9.66667H1.33325M11.8333 20.1667L20.9333 20.1667C22.24 20.1667 22.8934 20.1667 23.3926 19.9123C23.8316 19.6886 24.1886 19.3317 24.4123 18.8926C24.6666 18.3935 24.6666 17.7401 24.6666 16.4333V7.56667C24.6666 6.25988 24.6666 5.60648 24.4123 5.10736C24.1886 4.66831 23.8316 4.31136 23.3926 4.08765C22.8934 3.83333 22.24 3.83333 20.9333 3.83333H18.8333M11.8333 20.1667L14.1666 22.5M11.8333 20.1667L14.1666 17.8333M7.16659 20.1667H5.06658C3.7598 20.1667 3.1064 20.1667 2.60727 19.9123C2.16823 19.6886 1.81127 19.3317 1.58757 18.8926C1.33325 18.3935 1.33325 17.7401 1.33325 16.4333V7.56667C1.33325 6.25988 1.33325 5.60648 1.58757 5.10736C1.81127 4.66831 2.16823 4.31136 2.60727 4.08765C3.1064 3.83333 3.7598 3.83333 5.06659 3.83333H14.1666M14.1666 3.83333L11.8333 6.16667M14.1666 3.83333L11.8333 1.5" stroke="currentcolor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <Text
                        sx={() => ({
                            fontSize: 16,
                            fontWeight: 600,
                            marginLeft: "0.5rem"
                        })}
                    >
                        Deposit Payment
                    </Text>
                </Box>
                {props?.selectedPaymentOption === "deposit" ?
                    <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="14" fill="#FA5000" />
                        <path d="M20 9.5L11.75 17.75L8 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    :
                    <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#D0D0D0" />
                    </svg>
                }
            </Box>
        </Box>
        <Box style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '3rem',
        }}>
            <Button
                type="submit"
                sx={{
                    fontSize: "16px",
                    backgroundColor: '#FA5000',
                    padding: "1.2rem 2rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    '&:hover': {
                        backgroundColor: '#FA5000'
                    },
                    ".mantine-Button-inner": {
                        height: "fit-content"
                    }
                }}
                onClick={() => {
                    if (props?.selectedPaymentOption === "deposit") {
                        props?.proceedWithBooking(true)
                    } else {
                        props?.proceedWithBooking(false)
                    }
                }}
            >
                Proceed
            </Button>
        </Box>
    </Modal>
};

export default PaymentOptionModal;
